module.exports = require("react-immutable-pure-component");


//////////////////
// WEBPACK FOOTER
// external "react-immutable-pure-component"
// module id = 631
// module chunks = 0